import { render, staticRenderFns } from "./AddActivityGoods.vue?vue&type=template&id=7624ece0&scoped=true"
import script from "./AddActivityGoods.vue?vue&type=script&lang=js"
export * from "./AddActivityGoods.vue?vue&type=script&lang=js"
import style0 from "./AddActivityGoods.vue?vue&type=style&index=0&id=7624ece0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7624ece0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7624ece0')) {
      api.createRecord('7624ece0', component.options)
    } else {
      api.reload('7624ece0', component.options)
    }
    module.hot.accept("./AddActivityGoods.vue?vue&type=template&id=7624ece0&scoped=true", function () {
      api.rerender('7624ece0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/clientAnddistributionChild/AddActivityGoods.vue"
export default component.exports